type ShareParams = {
  url?: string
  title?: string
}

const siteName = process.env.NEXT_PUBLIC_WEBSITE_NAME ?? ''
const siteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL ?? ''

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '')
}

export function getShareUrl(url?: string): string {
  if (!url) {
    return trimTrailingSlash(siteUrl)
  }

  if (/^https?:\/\//i.test(url)) {
    return url
  }

  return `${trimTrailingSlash(siteUrl)}/${url.replace(/^\/+/, '')}`
}

export function getShareText(title?: string): string {
  return [title, siteName].filter(Boolean).join(' | ')
}

export function getXShareHref({ url, title }: ShareParams): string {
  const params = new URLSearchParams()
  const text = getShareText(title)

  if (text) {
    params.set('text', text)
  }
  params.set('url', getShareUrl(url))

  return `https://x.com/intent/tweet?${params.toString()}`
}

export function getFacebookShareHref({ url }: ShareParams): string {
  const params = new URLSearchParams()
  params.set('u', getShareUrl(url))

  return `https://www.facebook.com/sharer/sharer.php?${params.toString()}`
}

export function getBlueskyShareHref({ url, title }: ShareParams): string {
  const params = new URLSearchParams()
  const text = [getShareText(title), getShareUrl(url)]
    .filter(Boolean)
    .join('\n')
  params.set('text', text)

  return `https://bsky.app/intent/compose?${params.toString()}`
}

export function getLineShareHref({ url, title }: ShareParams): string {
  const params = new URLSearchParams()
  params.set('url', getShareUrl(url))

  const text = getShareText(title)
  if (text) params.set('text', text)

  return `https://social-plugins.line.me/lineit/share?${params.toString()}`
}

export function getHatenaBookmarkHref({ url }: ShareParams): string {
  const entryUrl = getShareUrl(url).replace(/^https?:\/\//, '')
  return `https://b.hatena.ne.jp/entry/s/${entryUrl}`
}
